import axiosInstance from '../api/axios';
import { IQuiz } from '../models/quiz';


export async function getLessonQuiz(lessonId: string): Promise<IQuiz> {
  const response = await axiosInstance.get(`/quiz/exercises/${lessonId}`);
  return response.data;
}

export async function answerQuiz(quizId: string, exerciseId: string, answerId: string, isCorrect: boolean): Promise<void> {
  const body = {
    exerciseId, answerId, isCorrect, quizId 
  }

  const response = await axiosInstance.post(`/quiz/answer`, body);
  return response.data;
}
